import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SnackAlert from "../../../shared/SnackAlert";
import Spinner from "../../../shared/Spinner";
import ParkingsView from "./ParkingsView";
import parkingServices from "../../../services/parking-service";
import moment from 'moment';
import permitServices from "../../../services/permit-service";
import parkingService from "../../../services/parking-service";

export default function ParkingsUtils(props) {
  let { id } = useParams();
  const PAGE_CONFIG = { pageSize: 25, page: 0 };
  const [spinner, setSpinner] = useState(false);
  const [msg, setMsg] = useState('');
  const [alert, setAlert] = useState(false);
  const [severity, setSeverity] = useState('');
  const [inputField, setInputField] = useState({});
  const [parking, setParking] = useState({ data: [], pagination: { ...PAGE_CONFIG, total: 0 } });
  const [searched, setSearched] = useState("");
  const [rows, setRows] = useState([]);
  const [paramFilter, setParamFilter] = useState({});
  const [pagination, setPagintion] = useState(PAGE_CONFIG)
  const [filter, setFilter] = useState({})
  const [sort, setSort] = useState({ sortBy: '_id', sort: -1 })
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [editPlateModal, setEditPlateModal] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [selectedParking, setSelectedParking] = useState({});

  useEffect(() => {
    getFilter();
  }, [id])

  const getFilter = async () => {
    let body = {};
    if (id === 'current') {
      body = {
        from: { $lte: new Date() },
        to: { $gte: new Date() }
      }
    } else if (id === 'all') {
      body = {}
    } else if (id === 'paid') {
      body = {
        amount: { $ne: '0' }
      }
    } else if (id === 'free') {
      body = {
        amount: '0'
      }
    } else if (id === 'not_externalized') {
      body = {
        is_externalized: false
      }
    } else if (id) {
      body = {
        _id: id
      }
    }
    setParamFilter(body);
    getParkings(body, { ...PAGE_CONFIG, ...sort });
  }

  const convertObjectToQueryString = (obj) => {
    return `?${Object.keys(obj)
      .map((key) => `${key}=${obj[key]}`)
      .join("&")}`;
  }

  const getParkings = async (e, query) => {
    setSpinner(true);
    const queryString = convertObjectToQueryString(query);
    const res = await parkingServices.getParkings({ ...e, ...{ org: props.org._id }}, queryString);
    setParking(res.data);
    setRows(res.data);
    setSpinner(false);
  }

  const onFilter = (obj) => {
    setFilter(obj);
    let queryObj = {
      ...pagination,
      ...sort,
      ...obj,
    };
    getParkings(paramFilter, queryObj);
  }

  const onPageChange = (obj) => {
    setPagintion(obj);
    let queryObj = {
      ...filter,
      ...sort,
      ...obj,
    };
    getParkings(paramFilter, queryObj);
  }

  const onSort = (obj) => {
    setSort(obj);
    let queryObj = {
      ...filter,
      ...pagination,
      ...obj,
    };
    getParkings(paramFilter, queryObj);
  }

  const requestSearch = (searchedVal) => {
    const filteredRows = rows.filter((row) => {
      return row.zone?.zone_name.toLowerCase().includes(searchedVal.toLowerCase())
        || row.parking_id.toString().includes(searchedVal)
        || row.city?.city_name.toLowerCase().includes(searchedVal.toLowerCase())
        || row.user?.fname.toLowerCase().includes(searchedVal.toLowerCase())
        || row.user?.email.toLowerCase().includes(searchedVal.toLowerCase())
        || row.plate.toLowerCase().includes(searchedVal.toLowerCase())
        || ((row.amount / 100).toFixed(2)).toString().toLowerCase().includes(searchedVal.toLowerCase())
        || (moment(row.from).format('ll hh:mm a')).toLowerCase().includes(searchedVal.toLowerCase())
        || (moment(row.to).format('ll hh:mm a')).toLowerCase().includes(searchedVal.toLowerCase())
    });
    setSearched(searchedVal);
    setParking(filteredRows);
  };

  const handleParkings = (e) => {
    let body = paramFilter;
    body["parking_type"] = e;
    getParkings(body);
  }

  const onTransactionHistory = async (e) => {
    setSpinner(true);
    const res = await permitServices.getTransactionDetail({ parking_id: e._id });
    setShowHistoryModal(true);
    setTransactionHistory(res.data);
    setSpinner(false);
  }
  
  const handleChange = (e) => {
    setInputField({ ...inputField, [e.target.name]: e.target.name == 'plate' ? e.target.value.toUpperCase() : e.target.value });
  };

  const handleEditPlate = async (e) => {
      e.preventDefault();
      setSpinner(true);
      const res = await parkingService.editParkingPlate({parking_id: selectedParking._id, plate: inputField.plate});
      if(res.data.status == 'error'){
        setMsg(props.literals[res.data.message]);
        setSeverity('error');
        setAlert(true);
      }else if(res.data.status == 'b_error'){
        setMsg(res.data.message);
        setSeverity('error');
        setAlert(true);
      } else{
        setMsg(props.literals.plate_edited_successfully);
        setSeverity('success');
        setAlert(true);
        setParking({
          data: parking.data.map(x=>{
              if(x._id == selectedParking._id){
                x.plate = inputField.plate;
                x.no_of_times_plate_edited = res.data.no_of_times_plate_edited;
              }
              return x;
            }),
          pagination: parking.pagination
        })
        setEditPlateModal(false);
      }
      setSpinner(false);
  }
  
  const handleCancelPermit = async (e) => {
    e.preventDefault();
    // setSpinner(true);
    const res = await permitServices.cancelPermit({parking_id: selectedParking._id, note: inputField.note, refund_amount: inputField.refund_amount});
    if(res.data.status == 'error'){
      setMsg(props.literals[res.data.message]);
      setSeverity('error');
      setAlert(true);
    }else if(res.data.status == 'b_error'){
      setMsg(res.data.message);
      setSeverity('error');
      setAlert(true);
    } else{
      setMsg(props.literals.permit_cancelled_successfully);
      setSeverity('success');
      setAlert(true);
      setParking({
        data: parking.data.map(x=>{
            if(x._id == selectedParking._id){
              x.to = res.data.to;
              x.status = res.data.status;
              x.note = res.data.note;
              x.refund_amount = res.data.refund_amount
            }
            return x;
          }),
        pagination: parking.pagination
      })
      setNoteModal(false);
    }
    setSpinner(false);
  }

  const externalizeParking = async (e) => {
    setSpinner(true);
    const res = await parkingService.externalizeParking({id: e._id});
    if(res.data.status == 'error'){
      setMsg(props.literals[res.data.message]);
      setSeverity('error');
      setAlert(true);
      setParking({
        data: parking.data.map(x=>{
            if(x._id == e._id){
              x.external_request = res.data.external_request;
            }
            return x;
          }),
        pagination: parking.pagination
      })
    }else{
      setMsg(props.literals.parking_externalize_successfully);
      setSeverity('success');
      setAlert(true);
      setParking({
        data: parking.data.map(x=>{
            if(x._id == e._id){
              x.is_externalized = true;
              x.externalize_status = 'success';
              x.external_request = res.data.external_request;
            }
            return x;
          }),
        pagination: parking.pagination
      })
    }
    setSpinner(false);
  }

  return (
    <>
      <ParkingsView
        inputField={inputField}
        parking={parking}
        searched={searched}
        literals={props.literals}
        org_id={props.org._id}
        transactionHistory={transactionHistory}
        showHistoryModal={showHistoryModal}
        editPlateModal= {editPlateModal}
        noteModal={noteModal}
        selectedParking={selectedParking}

        onPageChange={onPageChange}
        onFilter={onFilter}
        onSort={onSort}
        requestSearch={(e) => requestSearch(e)}
        handleParkings={(e) => handleParkings(e)}
        setSpinner={(e) => setSpinner(e)}
        onTransactionHistory={(e) => onTransactionHistory(e)}
        closeHistoryModal={() => setShowHistoryModal(false)}
        openEditPlateModal = {(e)=>{setSelectedParking(e); setEditPlateModal(true)}}
        openNoteModal = {(e)=>{setSelectedParking(e); setNoteModal(true)}}
        closeEditPlateModal = {()=>setEditPlateModal(false)}
        closeNoteModal = {()=>setNoteModal(false)}
        handleChange={(e)=>handleChange(e)}
        handleEditPlate={(e)=>handleEditPlate(e)}
        handleCancelPermit={(e)=>handleCancelPermit(e)}
        externalizeParking={(e)=>externalizeParking(e)}
      />
      <SnackAlert
        msg={msg}
        alert={alert}
        severity={severity}

        closeAlert={() => setAlert(!alert)}
      />
      <Spinner
        spinner={spinner}
      />
    </>
  );
}
